import * as mutationTypes from "../../mutation-types";
import * as Utils from "../../../libraries/utils";
import {ApmHelper} from "../../../domains2/libraries/ApmHelper";

const state = {
	persistedData: {
		globalSelectedShop: null,
		globalSelectedShopRefreshToken: null
	},
	shopRedirectUrl: null
};

const getters = {
	globalSelectedShop: state => state.persistedData.globalSelectedShop,
	shopRedirectUrl: state => state.shopRedirectUrl,
	deliveryMethods: state => state.persistedData.globalSelectedShop ? state.persistedData.globalSelectedShop.deliveryMethods : [],
	globalSelectedShopRefreshToken: state => state.persistedData.globalSelectedShopRefreshToken,
	useRecommendations: (state, getters) => {
		return getters.globalSelectedShop
			&& getters.globalSelectedShop.shopOptions
			&& (getters.globalSelectedShop.shopOptions.recommendationEngineEnabled || getters.globalSelectedShop.shopOptions.recommendationEngineEnabledBasket)
			&& getters.featureToggles.recommendationEngine;
	},
	useCarousel: (state, getters) => {
		return getters.globalSelectedShop
			&& getters.globalSelectedShop.shopOptions
			&& getters.globalSelectedShop.shopOptions.recommendationEngineEnabledCarousel
			&& getters.featureToggles.recommendationEngine;
	},
	doMarketingCardsRecommendations: (state, getters) => {
		return getters.globalSelectedShop
			&& getters.globalSelectedShop.shopOptions
			&& getters.globalSelectedShop.shopOptions.recommendationEngineEnabledMarketingCard
			&& getters.featureToggles.recommendationEngine;
	}
};

const actions = {
	async setGlobalSelectedShop({ commit, getters, dispatch }, shop) {
		if (getters.globalSelectedShop && getters.globalSelectedShop.id === shop.id) {
			// if there is already global selected shop and it is the same as passed shop skip everything
			return;
		}

		commit(mutationTypes.SET_GLOBAL_SELECTED_SHOP, shop);
		const cartProducts = getters.cartProducts || [];

		// Skip removing stuff if FT allows keeping cart on shop change
		if (!getters.featureToggles.enableNewChangeRestaurant && cartProducts.length) {
			const productCatalog = getters.productCatalog;
			let productIdsToRemove = [];

			// If catalog is missing or empty remove all cart products
			const isCatalogLoaded = productCatalog && Array.isArray(productCatalog.products) && productCatalog.products.length;
			if (!isCatalogLoaded) {
				productIdsToRemove = cartProducts.map(cp => cp.productId);
			} else {
				const missingOrInvalidItems = [];
				const itemsDisabledInShop = [];
				for (const selection of cartProducts) {
					let product = null;
					try {
						product = productCatalog.getProduct(selection.productId);
					} catch (_) {
						// Product not found in catalog, remove from cart
						missingOrInvalidItems.push(selection.productId);
						continue;
					}
					// Product found → check assortment rules
					const rules = product.assortmentRules;
					const ruleExists =
									Array.isArray(rules) &&
									rules.some(r => r.shopId === shop.id);
					if (ruleExists) {
						itemsDisabledInShop.push(product.id);
					} else {
						// Product exists but is not allowed in this shop
						missingOrInvalidItems.push(product.id);
					}
				}
				productIdsToRemove = [...itemsDisabledInShop, ...missingOrInvalidItems];
			}
			await dispatch(mutationTypes.REMOVE_FROM_CART, productIdsToRemove);
		}

		ApmHelper.addLabel("shopId", shop.id);
		ApmHelper.addLabel("shortShopId", shop.id.split("-")[4]);
	},
	resetGlobalSelectedShop({ commit }) {
		commit(mutationTypes.SET_GLOBAL_SELECTED_SHOP, null);

		ApmHelper.addLabel("shopId", "");
		ApmHelper.addLabel("shortShopId", "");
	}
};

const mutations = {
	[mutationTypes.SET_GLOBAL_SELECTED_SHOP](state, shop) {
		state.persistedData.globalSelectedShop = Utils.copyObject(shop);
	},
	[mutationTypes.UNSET_GLOBAL_SELECTED_SHOP](state) {
		state.persistedData.globalSelectedShop = null;
	},
	[mutationTypes.SET_REDIRECT_URL](state, redirectUrl) {
		state.shopRedirectUrl = redirectUrl;
	},
	[mutationTypes.SET_GLOBAL_SELECTED_SHOP_REFRESH_TOKEN] (state, shopRefreshToken) {
		state.persistedData.globalSelectedShopRefreshToken = shopRefreshToken;
	}
};

export default {
	state,
	getters,
	actions,
	mutations
};
